import React, { Component } from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { connect } from "@common/components/base.component";
import Loader from "@common/externos/components/loader/loader";
import Navbar from "@common/externos/components/navbar/navbar.externo";
import BackToTop from "@common/externos/components/backToTop/backToTop.externo";
import * as commonActionType from "@common/store/common/common.actionsType";

class LayoutExterno extends Component {
  componentDidMount() {
    PubSub.subscribe(commonActionType.REDIRECT, this.onRedirect.bind(this));
  }

  onRedirect(action, route) {
    this.props.routerManager.redirect(route);
  }

  render() {
    return (
      <Tooltip position="top" anchorElement="target" openDelay={0}>
        <Loader />
        <Navbar children={this.props.children} title={this.props.title} />
        <BackToTop />
      </Tooltip>
    );
  }
}

export default connect()(LayoutExterno);
